export const getImageUrlData = (imageUrl: string) => {
  const imageURL = new URL(imageUrl);
  const searchParams = new URLSearchParams(imageURL.search);
  const studyIUID = searchParams.get("studyUID");
  const seriesIUID = searchParams.get("seriesUID");
  const instanceIUID = searchParams.get("objectUID");
  const imageData = { studyIUID, seriesIUID, instanceIUID };
  return imageData;
};
